import Vue from 'vue';

const mutations = {
  setCurrentUser(state, val) {
    state.currentUser = val;
  },
  setFetchingUserData(state, val) {
    state.fetchingUserData = val;
  },
  setUserProfile(state, val) {
    const keys = Object.keys(val);
    const values = Object.values(val);
    Object.keys(val).forEach((key, index) => {
      Vue.set(state.userProfile, key, values[index]);
    });
    state.userProfile = val;
  },
  setCollaborators(state, val) {
    state.collaborators = val;
  },
  isUsernameValid(state, value) {
    state.isUsernameValid = value;
  }
};

export default mutations;
